<template>
  <div class="out">
    <div class="page-title">
      <div class="container">
        <b-jumbotron
          :header="header"
          style="color:white;background-color: rgba(0, 0, 0, 0);width:80%"
        >
          <h1>高成长型企业SaaS管理云</h1>
          <hr class="my-4">
          <p>助力成长型企业实现匹配业务快速发展的数字化创新管理</p>
        </b-jumbotron>
      </div>
    </div>
    <div class="title">
      <div style="display:flex;padding-top:100px;padding-bottom:100px">
        <img src="./xk1.png">
      </div>
    </div>
    <div style="background:#e7f0fa">
      <div class="title">
        <div style="display:flex;padding-top:100px;padding-bottom:100px">
          <img src="./xk2.png">
        </div>
      </div>
    </div>
    <div class="title">
      <div style="display:flex;padding-top:100px;padding-bottom:100px">
        <img src="./xk3.png">
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Cosmic',
  data() {
    return {
      header: '金蝶云·星空',
      leader: '面向大企业、央国企的数字化转型SaaS解决方案，助力大企业实现转型升级和创新发展'
    }
  },

  methods: {
    back() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.out{
  display: inline-block;
  vertical-align:top;
  width:100%;
}

.title {
  width: 1200px;
  text-align: center;
  margin: 0 auto;
}

.page-title {
  background: url('https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202110/261630539a2i.jpg') no-repeat;
  background-size: 100% 100%;
  height: 500px;
  text-align: left;
  padding-top: 60px;
  padding-bottom: 2px;
  /* max-width: 1200px; */
  margin: 0 auto;
  position: relative;
  z-index: 1;
}
</style>>



// WEBPACK FOOTER //
// src/components/galaxy.vue